// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__19N14","loginOrRegister":"Profile_loginOrRegister__3Y08S"};